var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDischargedPatientsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 28.3335V31.6668H35V28.3335C35 25.7502 33.8333 23.4335 31.9667 21.7668C40 22.5835 40 28.3335 40 28.3335ZM30 8.3335C32.7667 8.3335 35 10.5668 35 13.3335C35 16.1002 32.7667 18.3335 30 18.3335C29.4833 18.3335 28.9667 18.2502 28.5 18.1002C29.45 16.7502 30 15.1168 30 13.3335C30 11.5668 29.45 9.91683 28.5 8.56683C28.9667 8.41683 29.4833 8.3335 30 8.3335ZM21.6667 8.3335C24.4333 8.3335 26.6667 10.5668 26.6667 13.3335C26.6667 16.1002 24.4333 18.3335 21.6667 18.3335C18.9 18.3335 16.6667 16.1002 16.6667 13.3335C16.6667 10.5668 18.9 8.3335 21.6667 8.3335ZM31.6667 28.3335V31.6668H11.6667V28.3335C11.6667 24.6502 16.15 21.6668 21.6667 21.6668C27.1833 21.6668 31.6667 24.6502 31.6667 28.3335ZM0.773346 21.8668L4.31668 18.3335L0.773346 14.8002L3.13335 12.4335L6.66668 15.9835L10.2 12.4335L12.5667 14.8002L9.01668 18.3335L12.5667 21.8668L10.2 24.2335L6.66668 20.6835L3.13335 24.2335L0.773346 21.8668Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDischargedPatientsIcon);
export default __webpack_public_path__ + "static/media/DischargedPatientsIcon.ca2119d4.svg";
export { ForwardRef as ReactComponent };